import React, {useEffect, useState} from "react";
import {logoutUser, getUser, clearState} from '../../store/slices/userSlice';
import {useDispatch} from "react-redux";
import {Outlet} from "react-router-dom";

// Custom components
import Sidebar from './Sidebar';
import SidebarHeader from './SidebarHeader';
import SidebarContent from './SidebarContent';
import SidebarMenu from './SidebarMenu';
import SidebarMenuItem from './SidebarMenuItem';
import NavLink from './NavLink';
import Divider from './Divider';
import DropdownMenuItem, { DropdownSubMenuItem } from './DropdownMenuItem';

// React Icons
import { FaBars, FaComments, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { RiRobot2Fill } from "react-icons/ri";
import { BiSupport } from "react-icons/bi";
import { RiUserSettingsFill } from "react-icons/ri";

import ProfileCard from "../ProfileCard";

import "./index.css"

const Index = () => {
    const dispatch = useDispatch();
    const [isCollapsed, setIsCollapsed] = useState(() => {
        const saved = localStorage.getItem('sidebarCollapsed');
        return saved === 'true';
    });

    const logout = () => {
        dispatch(logoutUser())
        dispatch(clearState())
    };

    const toggleSidebar = () => {
        setIsCollapsed(prev => {
            const newValue = !prev;
            localStorage.setItem('sidebarCollapsed', newValue);
            return newValue;
        });
    };

    useEffect(() => {
        dispatch(getUser())
    })

    return (
        <div className="side-container">
            <Sidebar className={isCollapsed ? 'sidebar-collapsed' : ''} textColor="#fff" backgroundColor="#333">
                <SidebarHeader isCollapsed={isCollapsed} sufix={<FaBars className="fa-large toggle-btn" onClick={toggleSidebar}/>}>
                    <ProfileCard/>
                </SidebarHeader>

                <SidebarContent className="sidebar-content">
                    <SidebarMenu>
                        <NavLink to="/chat-support">
                            <SidebarMenuItem icon={<BiSupport />}>
                                {!isCollapsed && "Chats Support"}
                            </SidebarMenuItem>
                        </NavLink>

                        {/* AI Support with submenu */}
                        <DropdownMenuItem 
                            icon={<RiRobot2Fill />}
                            title="AI Support"
                            defaultRoute="/ai-support-chats"
                            isCollapsed={isCollapsed}
                        >
                            <DropdownSubMenuItem to="/ai-support-chats" icon={<FaComments />}>
                                Chats
                            </DropdownSubMenuItem>
                            <DropdownSubMenuItem to="/ai-support-settings" icon={<FaCog />}>
                                Settings
                            </DropdownSubMenuItem>
                        </DropdownMenuItem>
                        
                        <Divider />
                        <NavLink to="/settings">
                            <SidebarMenuItem icon={<RiUserSettingsFill />}>
                                {!isCollapsed && "User settings"}
                            </SidebarMenuItem>
                        </NavLink>
                        <div className="text-danger nav-style" onClick={logout}>
                            <SidebarMenuItem icon={<FaSignOutAlt />} className="text-danger">
                                {!isCollapsed && "Logout"}
                            </SidebarMenuItem>
                        </div>
                    </SidebarMenu>
                </SidebarContent>
            </Sidebar>
            <div className={`main-content ${isCollapsed ? 'main-content-collapsed' : ''}`}>
                <Outlet />
            </div>
        </div>
    );
};

export default Index;